import { Divider, Flex, Form, FormButton, Paper, SectionTitle } from '@shared/components';
import { FormProvider, type UseFormReturn } from 'react-hook-form';

import { type ExamEventDetailsStatusFormType } from '../../containers/exam-event-details-status-logic';
import { type BasicInformationReadonlyFieldProps } from '../basic-information-readonly-field';
import { type ExamCoursesReadonlyFieldProps } from '../exam-courses-readonly-field';
import { ExamEventInformationReadonlyFields } from '../exam-event-information-readonly-fields';
import {
  ExamEventStatusFormField,
  type ExamEventStatusFormFieldProps,
} from '../exam-event-status-form-field';
import { type ExamScheduleReadonlyFieldProps } from '../exam-schedule-readonly-field';
import { type LocationReadonlyFieldProps } from '../location-readonly-field';
import { type OptionalInformationReadonlyFieldProps } from '../optional-information-readonly-field';

export interface ExamEventDetailsStatusFormProps {
  form: UseFormReturn<ExamEventDetailsStatusFormType>;
  onSubmit: (data: ExamEventDetailsStatusFormType) => void;
  data: {
    basicInformation: BasicInformationReadonlyFieldProps;
    examSchedule: ExamScheduleReadonlyFieldProps;
    location: LocationReadonlyFieldProps['slotProps'];
    optionalInformation: OptionalInformationReadonlyFieldProps['slotProps'];
    examEventStatus: ExamEventStatusFormFieldProps;
    examCourses?: ExamCoursesReadonlyFieldProps;
  };
}

export default function ExamEventDetailsStatusForm(
  props: Readonly<ExamEventDetailsStatusFormProps>,
) {
  const { form, onSubmit, data } = props;
  const {
    basicInformation,
    examSchedule,
    location,
    optionalInformation,
    examEventStatus,
    examCourses,
  } = data;

  return (
    <FormProvider {...form}>
      <Form onSubmit={form.handleSubmit(onSubmit)}>
        <Paper
          sx={(theme) => ({
            flex: 1,
            p: theme.spacing(6),
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(6),
            borderRadius: theme.shape.rounded(2),
          })}
        >
          <ExamEventInformationReadonlyFields
            slotProps={{
              ...examSchedule,
              ...location,
              ...basicInformation,
              ...optionalInformation,
              name: basicInformation.examEventName,
              room: location?.room,
              numberOfExaminees: location?.numberOfExaminees,
              examCourses: examCourses,
            }}
          />
          <Divider />
          <SectionTitle title='Exam Event Status' />
          <ExamEventStatusFormField {...examEventStatus} />
        </Paper>
        <Flex
          sx={(theme) => ({
            justifyContent: 'flex-end',
            gap: theme.spacing(3),
            pt: theme.spacing(6),
          })}
        >
          <FormButton size='large' label='บันทึก' />
        </Flex>
      </Form>
    </FormProvider>
  );
}
